(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const media = window.matchMedia(MOBILE_QUERY);

  let header = null;
  let section = null;
  let triggerTop = 0;
  let ticking = false;

  const findElements = () => {
    header = document.querySelector('[data-wpe-header]');
    section = header ? header.closest('.wpe-header-section') : null;
  };

  const clearFixedState = () => {
    if (!header || !section) return;
    header.classList.remove('wpe-header--mobile-fixed');
    section.style.height = '';
  };

  const updateFixedState = () => {
    if (!header || !section) return;

    if (!media.matches) {
      clearFixedState();
      return;
    }

    const shouldFix = window.scrollY >= triggerTop;

    if (shouldFix) {
      if (!header.classList.contains('wpe-header--mobile-fixed')) {
        section.style.height = `${header.offsetHeight}px`;
        header.classList.add('wpe-header--mobile-fixed');
      }
    } else if (header.classList.contains('wpe-header--mobile-fixed')) {
      header.classList.remove('wpe-header--mobile-fixed');
      section.style.height = '';
    }
  };

  const measure = () => {
    findElements();
    if (!header || !section) return;

    clearFixedState();
    triggerTop = section.getBoundingClientRect().top + window.scrollY;
    updateFixedState();
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateFixedState();
      ticking = false;
    });
  };

  const init = () => {
    measure();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', () => window.requestAnimationFrame(measure));
    media.addEventListener?.('change', () => window.requestAnimationFrame(measure));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(measure));
})();
